import { createContext, useEffect, useState } from 'react';

export type VdState = {};

const VdStore = createContext<VdState>({});

const { Provider } = VdStore;

export const VdProvider = ({ children }: any) => {
  const [vdState, setVdState] = useState<VdState>({});

  useEffect(() => {
    setVdState({});
  }, []);

  return <Provider value={vdState}>{children}</Provider>;
};
